'use client';

import { __assign } from '../../_virtual/_tslib.js';
import React__default from 'react';

var AddIcon = React__default.memo(function (_a) {
    var _b = _a.width, width = _b === void 0 ? 16 : _b, _c = _a.height, height = _c === void 0 ? 16 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.rotate, rotate = _e === void 0 ? 0 : _e, color = _a.color;
    return (React__default.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 50 50', className: className, style: __assign({ transform: "rotate(".concat(rotate, "deg)") }, (color ? { fill: color } : null)) },
        React__default.createElement("path", { d: 'M25 2C12.264 2 2 12.264 2 25s10.264 23 23 23 23-10.264 23-23S37.736 2 25 2zm0 2c11.664 0 21 9.336 21 21s-9.336 21-21 21S4 36.664 4 25 13.336 4 25 4zm-1 9v11H13v2h11v11h2V26h11v-2H26V13h-2z' })));
});

export { AddIcon as default };
//# sourceMappingURL=index.js.map
